import api from 'utils/apiClient';

export const getNews = (params) => {
  return api.get('/news', { params });
};

export const createNews = (data) => {
  return api.post('/news', data);
};

export const editNews = (id, data) => {
  return api.patch(`/news/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    notification: {
      visible: false,
    },
  });
};

export const deleteNews = (id) => {
  return api.delete(`/news/${id}`);
};
